export default "__VITE_ASSET__BoC7fciv__"